import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
// Class: GameInputFinger
var GameInputFinger = /** @class */ (function (_super) {
    __extends(GameInputFinger, _super);
    function GameInputFinger() {
        return _super.call(this) || this;
    }
    // Called whenever the class is initialized.
    GameInputFinger.classInitializer = null;
    // List of static symbols to link.
    GameInputFinger.classSymbols = null; // [];
    // List of instance symbols to link.
    GameInputFinger.instanceSymbols = null; // [];
    GameInputFinger.THUMB = 'thumb';
    GameInputFinger.INDEX = 'index';
    GameInputFinger.MIDDLE = 'middle';
    GameInputFinger.UNKNOWN = 'unknown';
    return GameInputFinger;
}(ASObject));
export { GameInputFinger };
